import React from "react";
import { BsDiscord, BsTwitter } from "react-icons/bs";

export default function LendingFooter() {
  return ( 
      <footer id="footer" style={{backgroundColor:"#c0c0c5"}}>
        <div
          className=""
          style={{ marginLeft: "31vw", alignItems: "center", display: "flex" }}
        >
          Made with ❤️ for the community
        </div> 
        
      </footer> 
  );
}
